import { useCallback, useEffect, useState } from "react"
import { Template } from "../../Components/Template/template"
import {
    AlertType, classBorderLabelDark, classbtColunasAzul, classbtColunasVermelho, classDivBackground, classDivBody, classDivTitulo,
    classInput, classInputDark, classLabel, classLabelDark, classWeigthDiv, Clientes, ClientesSearchBox, DadosBordero
} from "../../Utils/Types"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { ClientesService } from "../Clientes/ClientesService"
import { SearchBox } from "../../Components/SearchBox/SearchBox"
import { IoReceipt, IoSearch } from "react-icons/io5"
import { ContaAReceberService } from "./ContaAReceberService"
import moment from "moment"
import { GridRelRecibos } from "../../Components/GridProducts/GridRelRecibos"
import { Link } from 'react-router-dom'
import { BsBoxArrowInLeft } from "react-icons/bs"


export const ContaAReceberRecibos = () => {

    let dateI = moment()
        .utcOffset('-03:00')
        .add(-31, 'days')
        .format('YYYY-MM-DD');

    let dateF = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD');

    // -----------------------------------------------
    // ---------- ATRIBUTOS FEEDBACK -----------------
    // -----------------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // -----------------------------------------------
    // ------------- ATRIBUTOS -----------------------
    // -----------------------------------------------
    const [borderoList, setBorderoList] = useState<DadosBordero[]>([])

    const [clientes, setClientes] = useState<ClientesSearchBox[]>([])
    const [clientesList, setClientesList] = useState<ClientesSearchBox[]>([])
    const [idCliente, setIdCliente] = useState(0)

    const [datai, setDatai] = useState<string>(dateI)
    const [dataf, setDataf] = useState<string>(dateF)

    //const [searchBoxResponsivo, setSearchBoxResponsivo] = useState<boolean>(false)
    const [visibleSearchBoxCliente, setVisibleSearchBoxCliente] = useState<boolean>(false)


    //------------------------------------------------------------- REQUISIÇÃO API, ATALHOS E FOCUS ----------------------------------------------------------------------------//
    const getClientes = async () => {
        setLoading(true)

        try {

            const resp = await ClientesService.GetListCliente()
            setClientes(resp.data)
            setClientesList(resp.data)

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage("Não foi possível buscar os clientes")

        } finally {
            setLoading(false)
        }

    }

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement;
        if (target instanceof HTMLAnchorElement) {
            target.blur();
        }
    }, [])

    const handleKeyPressEnter = async (e: any) => {
        if ((e.code === "Enter" || e.code === "NumpadEnter") && !visibleSearchBoxCliente && !loading) {
            await handleFilterClick()
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPressEnter);

        return () => {
            document.removeEventListener('keydown', handleKeyPressEnter);
        };

    }, [datai, dataf, idCliente, visibleSearchBoxCliente, loading])

    useEffect(() => {
        getClientes()
    }, [])

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //--------------------------------------------------------------------------------------------- FILTROS ------------------------------------------------------------------------------------------//
    const handleChangeDtInicio = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
    }

    const handleChangeDtFim = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
    }

    const handleFilterClick = async () => {

        setVisible(false)
        setLoading(true)
        setBorderoList([])

        try {

            const dados = await ContaAReceberService.RelatorioBordero(idCliente, datai, dataf)
           

            if (dados.error === true) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(dados.msg || "")

            } else {
               setBorderoList(dados.data)
            }

        } catch (error) {
            setBorderoList([])
            setVisible(true)
            setMessageType("DANGER")
            setMessage("Não foi possível buscar os recibos.")

        } finally {
            setLoading(false)
        }
    }

    const toggleMenuFiltro = (event: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroRecibos") as HTMLDivElement
        let menuInputs = document.getElementById("divInputsRecibos") as HTMLDivElement

        handleInputFocus()

        if (menuFiltro) {

            menuFiltro.classList.toggle("max-h-[1000px]")
            menuFiltro.classList.toggle("max-h-[0px]")

            if (menuFiltro.classList.contains("max-h-[1000px]")) {

                //setSearchBoxResponsivo(true)
                menuInputs.classList.remove("invisible")

            } else {

                //setSearchBoxResponsivo(false)
                menuInputs.classList.add("invisible")

            }

            event.currentTarget.blur();
        }
    }

    const minimizarFiltro = () => {

        let menuFiltro = document.getElementById("divMenuFiltroRecibos") as HTMLDivElement
        let menuInputs = document.getElementById("divInputsRecibos") as HTMLDivElement

        if (menuFiltro) {

            menuFiltro.classList.remove("max-h-[1000px]")
            menuFiltro.classList.add("max-h-[0px]")

            //setSearchBoxResponsivo(false)

            menuInputs.classList.add("invisible")
        }
    }

    const handleInputFocus = () => {
        setVisibleSearchBoxCliente(false)
    }

    //--------------------------------------------------------------------------------------------- CLIENTE ------------------------------------------------------------------------------------------//
    const handleClearClienteSelecionado = useCallback(() => {
        const newClienteList = [...clientes || []]
        setClientesList(newClienteList)
        setIdCliente(0)

        setVisibleSearchBoxCliente(false)

    }, [clientes])

    const handleFilterClienteClick = useCallback(async (description: string) => {

        if (description === "") {

            const newClienteList = [...clientes || []]
            setClientesList(newClienteList || [])

        } else {

            const newClienteList = [...clientes || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setClientesList(newClienteList || [])
        }

    }, [clientes])

    const handleClienteSelectClick = useCallback(async (v: Clientes) => {

        if (v) {
            const newClienteList = [...clientes || []]
            setClientesList(newClienteList)
            setIdCliente(v.id)
        }

        setVisibleSearchBoxCliente(false)

    }, [clientes])

    const clickSearchBoxCliente = useCallback(() => {
        setVisibleSearchBoxCliente((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                inputFocusCliente()
            }
            return newState;
        })
    }, [])

    const inputFocusCliente = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cliente`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //----------------------------------------------------------------- FOCUS --------------------------------------------------------------------------------------//
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [])

    return (

        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`${classDivTitulo} grid grid-cols-12 gap-4 p-2`}>

                        <div className={`relative col-span-12 sm:col-span-6 xl:col-span-8 flex flex-row items-center`}>
                            <IoReceipt className={`mx-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Recibos</span>
                        </div>

                        <div className={`relative col-span-6 sm:col-span-3 xl:col-span-2`}>
                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/contaAreceber" className={`${classbtColunasVermelho} h-9`}>
                                <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                            </Link>
                        </div>

                        <div className={`relative col-span-6 sm:col-span-3 xl:col-span-2`}>
                            <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} onClick={toggleMenuFiltro} >
                                <span className={`w-full h-full flex justify-center items-center`}>Filtros</span>
                            </button>
                        </div>

                    </div>

                    <div id='divInputsRecibos' className={`relative invisible ease-in-out duration-[150ms]`}>

                        <div id='divMenuFiltroRecibos' className={`relative max-h-[0px] h-[300px] sm:h-[170px] md:h-[165px] xl:h-[110px] cursor-default bg-white dark:bg-slate-600 shadow-sm shadow-slate-400 dark:shadow-slate-800 border dark:border-slate-800 rounded-md overflow-y-hidden`} style={{ transitionDuration: "0ms, 300ms", transitionProperty: "background-color, max-height" }} />

                        <div className={`absolute top-0 w-full h-auto grid grid-cols-12 gap-4 py-7 px-3`}>

                            <div className={`relative col-span-12 xl:col-span-4 2xl:col-span-6 mt-1`}>
                                <SearchBox
                                    dataList={clientesList}
                                    idRegistro={idCliente || undefined}
                                    label='Cliente'
                                    componentId='cliente'
                                    visibleTAB={visibleSearchBoxCliente}
                                    clearDataClick={handleClearClienteSelecionado}
                                    setDataClick={handleClienteSelectClick}
                                    filterDataClick={handleFilterClienteClick}
                                    clicado={clickSearchBoxCliente}
                                />
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-1`}>
                                <input id='data-inicial-recibos' className={`${classInput} ${classInputDark} ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={datai} disabled={loading} onFocus={handleInputFocus} onChange={handleChangeDtInicio} />
                                <label htmlFor="data-inicial-recibos" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data da Baixa Inicial</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-1`}>
                                <input id='data-final-recibos' className={`${classInput} ${classInputDark} ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={dataf} disabled={loading} onFocus={handleInputFocus} onChange={handleChangeDtFim} />
                                <label htmlFor="data-final-recibos" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data da Baixa Final</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 2xl:col-span-2 mt-1`}>
                                <button tabIndex={-1} disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} `} onFocus={handleInputFocus} onClick={handleFilterClick} >
                                    <span className={`w-full h-full flex justify-center items-center`}>
                                        {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {!loading && `Pesquisar`} {loading && `Aguarde`}
                                    </span>
                                </button>
                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>

                        <GridRelRecibos duplicatas={borderoList} />

                    </div>

                </div>

            </div>

        </Template>

    )
}